import { getSessionStorage, StorageKey } from '@utils/StorageUtils';
import { Country, PageName } from '@utils/pageConfig/Types';
import { Action, HitlistsRetailerClientTypes } from '@state/actions/Type';

export interface HitlistsRetailerClientState {
  clientId: number;
  countries: Country[];
  clientName?: string;
  pageViewing?: PageName;
}

const getInitialState = () => {
  const storeHitlistsRetailerClient = JSON.parse(getSessionStorage(StorageKey.HitlistsRetailerClient) as string);

  if (storeHitlistsRetailerClient !== null) {
    return {
      clientId: storeHitlistsRetailerClient.clientId,
      countries: storeHitlistsRetailerClient.countries,
      pageViewing: storeHitlistsRetailerClient.pageViewing,
      clientName: storeHitlistsRetailerClient.clientName,
    };
  }

  return Object.freeze({
    clientId: -1, // -1 for default clientId
    countries: [{ id: '', name: '', currency: '' }],
    clientName: '',
  });
};

const HitlistsRetailerClientReducer = (
  state: HitlistsRetailerClientState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === HitlistsRetailerClientTypes.HitlistsRetailerClientUpdate) {
    return {
      ...state,
      clientId: action.payload.clientId,
      countries: action.payload.countries,
      pageViewing: action.payload.pageViewing,
      clientName: action.payload.clientName,
    };
  }
  return state;
};

export default HitlistsRetailerClientReducer;
